module.exports = __webpack_public_path__ + "static/media/crewlist-icon.bc7b877a.svg";